import React from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'shards-react';

const ComplaintConfirmationModal = ({ closeModal, handleSubmit, values }) => {
	const pdpaLink = 'http://www.nccc.org.my/v2/index.php/privacy-policy';
	return (
		<Modal
			open={true}
			toggle={closeModal}
			backdrop={true}
			backdropClassName="backdrop"
			modalClassName="modal"
			centered={true}
			role="dialog"
		>
			<ModalHeader className="bg-primary1">Acknowledgement</ModalHeader>
			<ModalBody>
				<p>
					By Submitting this Form, you hereby agree that NCCC may collect, obtain, store and process your
					personal data that you provide in this form for the purpose of receiving updates, news, promotional
					and marketing updates, news, promotional and marketing mails or materials from NCCC.
					<br />
					<br />
					You hereby give your consent to NCCC to:
					<br />
					- Personal information to establish your identity and background such as your full name, passport or
					identity card number, nationality and religion.
					<br />
					- Store and process your personal data. Personal data will be encrypted.
					<br />
					- Disclose your Personal Data to the relevant governmental authorities or third parties where
					required by law or for legal purposes.
					<br />
					<br />I affirm that all information in this e-aduan form is correct and true. / Saya mengaku bahawa
					maklumat yang tercatat di dalam borang e-aduan ini adalah betul dan benar.
				</p>

				<Button
					onClick={() => {
						window.open(pdpaLink);
					}}
				>
					See PDPA Policy
				</Button>
			</ModalBody>
			<ModalFooter className="home-buttons d-flex w-100 justify-content-between">
				<Button
					theme="danger"
					type="dismiss"
					onClick={() => {
						closeModal();
					}}
				>
					Cancel
				</Button>
				<Button
					theme="success"
					type="submit"
					name="go_profile"
					onClick={() => {
						console.log(values);
						handleSubmit(values);
					}}
				>
					I, acknowledge / Saya Mengaku
				</Button>
			</ModalFooter>
		</Modal>
	);
};

export default ComplaintConfirmationModal;
